import { Injectable } from "@angular/core";

@Injectable()
export class PermissionService {

    public static permissionList: Array<permissionRecord> = [];
    public static userInfo = PermissionService.getDefault();
    private static getDefault() {
        return {
            level: 0,
            group: -1
        };
    }
    public invokeList(list) {
        PermissionService.permissionList = list || [];
    }

    public invokeUser(user: userStatus) {

        PermissionService.userInfo = user || PermissionService.getDefault();
    }

    public getPermission() {
        return PermissionService.permissionList;
    }
    /*
    ** 方法是否可以执行
    */
    public isValid(actionName: SysName): boolean {
        var index = PermissionService.permissionList.findIndex(p => p.sysName == actionName);
        //console.log(index,actionName,PermissionService.permissionList);
        return index > -1 && PermissionService.permissionList[index].isValid;
    }
}


export enum SysName {
    None = 0,

    PublishComments, // 发表评论

    ViewGuestVideo, // 观看游客视频

    ViewMemberVideo, // 观看会员视频

    ViewVIPVideo, // 观看VIP视频

    VideoDownload, // 视频下载

    ScecretScj, // 私密收藏夹

    AutoPlayNext, // 自动播放下一集

    ScjRenewReminder, // 收藏夹通知

    // 记录播放时间
    RecordLastPlay,
    // 上传视频
    UploadVideo,

    //创建频道
    CreateChannel,

    /// <summary>
    /// 发表投票
    /// </summary>
    PublishVote,

    /// <summary>
    /// 自定义弹幕
    /// </summary>
    CustomBarrage,


    /// <summary>
    /// VIP专属表情
    /// </summary>
    VIPFaceExpression,
    /// <summary>
    /// 倍速播放
    /// </summary>
    PlayRatio,

    /// <summary>
    /// 过滤暂停广告
    /// </summary>
    FilterPauseAds,

    /// <summary>
    /// 过滤前置广告
    /// </summary>
    FilterFrontAds,
}

interface permissionRecord {
    sysName: SysName;
    isValid: boolean
}

interface userStatus {
    level: number;
    group: number;
}
